"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleDropdownEvents = undefined;

var _ramda = require("ramda");

var accessibilityUtility = {
    handleDropdownEvents: function handleDropdownEvents(element, event, dropdownId, currentRef, firstElement, isLastElement, callBack, ismultiSelectDropdown) {
        if (event.key !== "Tab") {
            event.preventDefault();
        }

        if (event.key === "Tab" && !event.shiftKey) {
            if ((0, _ramda.indexOf)("clicked", document.querySelector(dropdownId + "> .dropdown-display").classList) >= 0) {
                document.querySelector(dropdownId + "> .dropdown-display").click();
            }
        }

        if (event.key === "Tab" && event.shiftKey) {
            if ((0, _ramda.indexOf)("clicked", document.querySelector(dropdownId + "> .dropdown-display").classList) === -1) {
                document.querySelector(dropdownId + "> .dropdown-display").click();
            }
        }

        if (event.key === "Enter") {
            callBack();
            if ((0, _ramda.indexOf)("clicked", document.querySelector(dropdownId + "> .dropdown-display").classList) >= 0) {
                document.querySelector(dropdownId + "> .dropdown-display.clicked").click();
                document.querySelector(dropdownId + " .dropdown-list-item:last-child").focus();
            }
        }

        this.handleArrowUpDownEvents(event, element, currentRef, firstElement, ismultiSelectDropdown);
    },
    handleTabEvents: function handleTabEvents(element, event, dropdownId, currentRef, firstElement, callBack) {
        if (event.key !== "Tab") {
            event.preventDefault();
        }

        if (event.key === "Enter") {
            callBack();
            if (!(0, _ramda.isNil)(document.querySelector(dropdownId + "> .dropdown-display"))) {
                if ((0, _ramda.indexOf)("clicked", document.querySelector(dropdownId + "> .dropdown-display").classList) >= 0) {
                    document.querySelector(dropdownId + "> .dropdown-display.clicked").click();
                }
            }
        }

        if (event.key === "ArrowRight") {
            if ((0, _ramda.isNil)(element[currentRef].current.nextElementSibling)) {
                this.focusItemForReference(element[firstElement]);
            } else {
                this.focusNextItem(element[currentRef]);
            }
        }

        if (event.key === "ArrowLeft") {
            if ((0, _ramda.isNil)(element[currentRef].current.previousElementSibling)) {
                this.focusItemForReference(element[firstElement]);
            } else {
                this.focusPreviousItem(element[currentRef]);
            }
        }
    },
    handleAccordionEvents: function handleAccordionEvents(element, event, dropdownId, currentRef, firstElement, callBack) {
        if (event.key !== "Tab") {
            event.preventDefault();
        }

        if (event.key === "Enter") {
            callBack();
        }

        if (event.key === "ArrowDown") {
            if ((0, _ramda.isNil)(element[currentRef].current.nextElementSibling)) {
                element[firstElement].current.firstElementChild.focus();
            } else {
                element[currentRef].current.nextElementSibling.firstElementChild.focus();
            }
        }

        if (event.key === "ArrowUp") {
            if ((0, _ramda.isNil)(element[currentRef].current.previousElementSibling)) {
                element[firstElement].current.firstElementChild.focus();
            } else {
                element[currentRef].current.previousElementSibling.firstElementChild.focus();
            }
        }
    },
    handleFocusTrap: function handleFocusTrap(element, event, nextElementId) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (!(0, _ramda.isNil)(document.querySelector(nextElementId))) {
                document.querySelector(nextElementId).focus();
            }
        }
    },
    handleArrowUpDownEvents: function handleArrowUpDownEvents(event, element, currentRef, firstElement, ismultiSelectDropdown) {
        if (event.key === "ArrowDown") {
            if (ismultiSelectDropdown) {
                if (element[currentRef].current.classList.contains('select-all')) {
                    if (!(0, _ramda.isNil)(element[currentRef].current.parentElement.nextElementSibling)) {
                        element[currentRef].current.parentElement.nextElementSibling.firstChild.firstChild.focus();
                    }
                } else {
                    if ((0, _ramda.isNil)(element[currentRef].current.parentElement.parentElement.nextElementSibling)) {
                        if (element[firstElement].current.attributes.hasOwnProperty('disabled')) {
                            element[firstElement].current.parentElement.nextElementSibling.firstChild.firstChild.focus();
                        } else {
                            this.focusItemForReference(element[firstElement]);
                        }
                    } else {
                        element[currentRef].current.parentElement.parentElement.nextElementSibling.firstChild.firstChild.focus();
                    }
                }
            } else {
                if ((0, _ramda.isNil)(element[currentRef].current.nextElementSibling)) {
                    this.focusItemForReference(element[firstElement]);
                } else {
                    this.focusNextItem(element[currentRef]);
                }
            }
        }

        if (event.key === "ArrowUp") {
            if (ismultiSelectDropdown) {
                if (!(0, _ramda.isNil)(element[currentRef].current.parentElement.parentElement.previousElementSibling)) {
                    if (element[currentRef].current.parentElement.parentElement.previousElementSibling.firstChild.classList.contains('select-all')) {
                        if (!element[firstElement].current.attributes.hasOwnProperty('disabled')) {
                            this.focusItemForReference(element[firstElement]);
                        }
                    } else {
                        element[currentRef].current.parentElement.parentElement.previousElementSibling.firstChild.firstChild.focus();
                    }
                }
            } else {
                if ((0, _ramda.isNil)(element[currentRef].current.previousElementSibling)) {
                    this.focusItemForReference(element[firstElement]);
                } else {
                    this.focusPreviousItem(element[currentRef]);
                }
            }
        }
    },
    focusItemForReference: function focusItemForReference(ref) {
        if (!(0, _ramda.isNil)(ref.current)) {
            ref.current.focus();
        }
    },
    focusNextItem: function focusNextItem(ref) {
        ref.current.nextElementSibling.focus();
    },
    focusPreviousItem: function focusPreviousItem(ref) {
        ref.current.previousElementSibling.focus();
    },
    handleEnterClick: function handleEnterClick(element, event, callBack) {
        if (event.key === "Enter") {
            callBack();
        }
    },
    handleSpaceOrEnterClick: function handleSpaceOrEnterClick(element, event, callBack) {
        if (event.key === "Enter" || event.charCode === 32) {
            callBack();
        }

        if (event.charCode === 32) {
            event.preventDefault();
        }
    }
};

exports.default = accessibilityUtility;
var handleDropdownEvents = accessibilityUtility.handleDropdownEvents;
exports.handleDropdownEvents = handleDropdownEvents;